import { Box, Container, Flex, Image, List, Stack, Text } from "@chakra-ui/react";
import Head from "next/head";

import Sidebar from "@/sections/estandares-codigo/Sidebar";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const CodigoDeEtica = () => {
    return (
        <>
            <Head>
                <title>Código de Ética | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/codigo-conducta" />
                <link
                    rel="alternate"
                    href="https://grupoguia.mx/codigo-conducta"
                    hreflang="es-mx"
                />
            </Head>
            <Header />
            <Container maxWidth={{ base: "7xl", md: "8xl" }} pt={{ base: 14, md: 24 }} mx="auto">
                <Flex direction={{ base: "column", md: "row" }}>
                    <Sidebar selected="codigo" />
                    <Box pb={20} minHeight="100vh" mt={16} maxW={{ base: "100%", md: "80%" }}>
                        <Stack>
                            <Text
                                fontSize={{ md: "2xl", base: "xl" }}
                                align="start"
                                color="accent.500"
                                fontWeight="700"
                            >
                                CÓDIGO DE ÉTICA GRUPO GUIA
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "xl" }}
                                align="start"
                                mb="8"
                                color="accent.500"
                                fontWeight="700"
                            >
                                ESTRUCTURA BASE
                            </Text>
                        </Stack>
                        <Stack my={4}>
                            <Text
                                fontSize={{ md: "2xl", base: "xl" }}
                                align="start"
                                mb="8"
                                color="accent.500"
                                fontWeight="700"
                            >
                                1. MENSAJE DEL CONSEJO DE ADMINISTRACIÓN
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                align="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                Somos los responsables en Grupo Guía de fijar las políticas,
                                lineamientos y en general reglas aplicables para la forma de
                                relacionarnos.
                                <br />
                                Nuestro compromiso es informar con claridad a cualquier persona que
                                guarde relación con Grupo Guía, los estándares de conducta aceptados
                                y permitidos.
                                <br /> <br />
                                En sentido opuesto, aquellas conductas que se encuentran
                                estrictamente prohibidas. Este documento orienta también a cualquier
                                persona que reciba un trato contrario a lo mencionado en estos
                                estándares de conducta sobre la forma en que puede iniciar una
                                denuncia interna.
                                <br /> <br />
                                Grupo Guía respeta el principio a la dignidad humana, reprobando
                                cualquier conducta que no tenga los estándares mínimos que
                                representen las virtudes de la compañía.
                            </Text>
                        </Stack>
                        <Stack my={4}>
                            <Text
                                fontSize={{ md: "2xl", base: "xl" }}
                                align="start"
                                mb="8"
                                color="accent.500"
                                fontWeight="700"
                            >
                                2. INTRODUCCIÓN
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                align="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                <strong>A. Virtudes de la empresa</strong>
                                <br />
                                ¿Cuáles son las virtudes que representan a Grupo Guía?
                                <br /> <br />
                                <strong>B. ¿Cuáles son los estándares de conducta de Guía? </strong>
                                <br />
                                En Guía, estamos comprometidos con el respeto y la dignidad humana,
                                por ello hemos establecido estándares de conducta que buscan cuidar
                                que todos los involucrados con GRUPO GUÍA reciban un trato digno,
                                buscando un espacio libre de acoso y no discriminación. Para más
                                información se pueden consultar nuestros estándares de conducta en
                                nuestro sitio web o bien directamente en el siguiente link:{" "}
                                <a
                                    href="https://grupoguia.mx/estandares-de-conducta"
                                    style={{ textDecoration: "underline" }}
                                >
                                    https://grupoguia.mx/estandares-de-conducta.{" "}
                                </a>
                                <br /> <br />
                                <strong>C. ¿Qué no son? </strong>
                                <br />
                                Nuestros estándares, por más detallados que puedan ser, no pueden
                                anticipar medidas para todas las situaciones o retos que surgirán en
                                el trabajo, funcionan como una guía, no una descripción exhaustiva
                                de las políticas de la empresa.
                                <br /> <br />
                                <strong>D. Aplicación para todo el personal de la empresa </strong>
                                <br />
                                Los estándares de conducta deben ser aplicables a todo el personal,
                                comisionistas, proveedores de servicio, clientes y en general
                                cualquier persona que tenga una relación con Guía consecuencia de
                                una relación jurídica o incluyendo una relación comercial, los
                                miembros del consejo directivo, así como aquellas que personas que
                                actúan en nombre de Guía.
                                <br /> <br />
                                Al formar parte de Guía uno se compromete de manera profesional a
                                entender las políticas y leyes que aplican a su trabajo o actividad
                                comercial y a cumplirlas en todo momento.
                                <br /> <br />
                                Además, para cumplir con estas normas, es imperativo que nos
                                planteemos las preocupaciones cuando debemos de hacerlo en los casos
                                correspondientes:
                            </Text>
                            <List.Root gap={0} ml={4}>
                                <List.Item>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                    >
                                        No se está seguro del curso de acción adecuado y se necesita
                                        consejo
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                    >
                                        Cree que alguien que actúa en nombre de la empresa está
                                        haciendo algo, o está a punto de hacerlo, que viola nuestras
                                        virtudes o la ley; o
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                    >
                                        Cree que puede haber participado en alguna conducta
                                        inapropiada.
                                    </Text>
                                </List.Item>
                            </List.Root>
                            <Image
                                src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/code.svg"
                                alt="Codigo de Conducta"
                                maxW="60%"
                                w="60%"
                                my={4}
                            />
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                align="start"
                                color="accent.500"
                                fontWeight={400}
                                pb={2}
                            >
                                <strong>E. Responsabilidades de los directivos</strong>
                                <br />
                                Al ser directivo, uno tiene voto de confianza y por lo tanto mayores
                                responsabilidades bajo los estándares de conducta. Los directivos
                                influyen en gran medida en las virtudes y cultura de la empresa, en
                                consecuencia, se espera que los directivos personifiquen las
                                virtudes de Guía con su propia conducta, actuando con prontitud
                                cuando llegue a su conocimiento algo que vaya en contra de los
                                estándares de conducta, otras políticas o la ley.
                                <br /> <br />
                                <strong>F. Mecanismos para obtener ayuda</strong>
                                <br />
                                Definir con quién ponerse en contacto para obtener ayuda, el
                                supervisor o directivo puede ser un buen punto de partida. También
                                puedes obtener ayuda del director de people experience o de
                                dirección jurídica. Tu unidad de negocio o región correspondiente,
                                pueden establecer modos adicionales de comunicar sus problemas y
                                preocupaciones. Lo más importante es que se plantee la preocupación
                                con rapidez y eficacia.
                                <br /> <br />
                                <strong>G. Tolerancia 0 a las represalias</strong>
                                <br />
                                El compromiso con las virtudes de Guía, implica que nunca tendrás
                                que enfrentarte a represalias si informas de una preocupación,
                                infracción o participación en alguna investigación. Se define
                                represalia como cualquier acción que afecte a las condiciones de
                                empleo, como cese, suspensión, descenso de categoría laboral o
                                reducción de la compensación laboral. Todo empleado, asesor o
                                proveedor de servicios que intente realizar represalias se verá
                                sujeto a acción disciplinaria, incluyendo el despido. Si se recibe
                                un reporte relativo a alguna infracción de la política o la ley, se
                                investigará o documentará de conformidad con los procedimientos de
                                investigación aprobados de Guía. Una vez que se registre en el
                                sistema de Guía una denuncia de falta grave de falta de conducta
                                indebida, conforme a los estándares de conducta, se realizará una
                                investigación oportuna, detallada, congruente y objetiva. Ningún
                                empleado tiene permitido realizar su propia investigación sin
                                autorización del comité de ética.
                                <br /> <br />
                                <strong>H. Programa de Ética y Cumplimiento Guía</strong>
                                <br />
                                Un programa de ética que funcione para reforzar las virtudes de Guía
                                y garantizar el cumplimiento de las políticas de la empresa, además
                                de las normas y leyes vigentes y aplicables a Guía. Es un programa
                                que debe cumplir con seis objetivos: - Prevención de riesgos que
                                vayan en contra del cumplimiento. - Mitigar el riesgo de posibles
                                fallas en el cumplimiento. - Minimizar las consecuencias de las
                                fallas en el cumplimiento. - Identificar y corregir las deficiencias
                                en cumplimiento. - Fomentar la ética y responsabilidad en
                                cumplimiento en toda la empresa. - Sancionar todas aquellas acciones
                                que vayan en contra de las virtudes y estándares de conducta de
                                Guía.
                                <br /> <br />
                                <strong>I. Cumplimiento con la ley</strong>
                                <br />
                                Ninguna razón justifica la infracción de la ley o animar a alguien
                                que lo haga. Al ofrecer servicios inmobiliarios, la legislación
                                gobierna casi todos los aspectos de nuestras actividades
                                comerciales. Por lo tanto, se debe de poner en contacto con el
                                Departamento Legal si no se está seguro sobre un posible curso de
                                acción al navegar en los aspectos de cumplimiento que pueden
                                resultar confusos, ya que es muy importante para Guía evitar
                                sanciones para ti, tus compañeros o para la empresa.
                                <br /> <br />
                            </Text>
                        </Stack>
                        <Stack my={4}>
                            <Text
                                fontSize={{ md: "2xl", base: "xl" }}
                                align="start"
                                mb="8"
                                color="accent.500"
                                fontWeight="700"
                            >
                                3. CONDUCTA DENTRO DE GUÍA
                            </Text>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/equality.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>
                                            A. Igualdad de oportunidades y respetar la diversidad
                                        </strong>
                                        <br />
                                        Guía siempre buscará atraer a las personas con más talento y
                                        experiencia. Busca ofrecer un ambiente en el que se pueda
                                        competir y tener éxito de acuerdo a tus habilidades. Se
                                        invita a todos los que trabajan en Guía a contribuir de modo
                                        significativo y se les reconoce e incentiva de conformidad
                                        con ello. Guía está comprometida en ofrecer oportunidades
                                        laborales de forma igualitaria. Dentro de Guía no permitimos
                                        ni toleramos ningún tipo de discriminación como lo puede
                                        ser, raza, color, nacionalidad, religión, identidad sexual,
                                        orientación sexual, edad, estado civil o cualquier tipo de
                                        discriminación que no tenga una justificación razonable y
                                        legitima.
                                        <br /> <br />
                                    </Text>
                                </Stack>
                            </Flex>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                align="start"
                                color="accent.500"
                                fontWeight={400}
                                my={4}
                            >
                                <strong>B. Impedir el acoso</strong>
                                <br />
                                La empresa debe de implementar estrictas medidas contra el acoso.
                                Estas medidas deben de describir las conductas prohibidas y
                                establecer los procedimientos adecuados para escalar las
                                preocupaciones e informar de las sanciones.
                                <br /> <br />
                            </Text>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                            >
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/prevent.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        Todos nuestros compañeros merecen que se les trate con
                                        dignidad y respeto y no deben de verse sometidos a conductas
                                        ofensivas ni degradantes. El acoso puede manifestarse de
                                        muchas maneras, como lo pueden ser, insinuaciones sexuales
                                        abiertas, comentarios casuales, gestos ofensivos,
                                        independientemente de la intención. Para cumplir con estas
                                        medidas contra el acoso se puede empezar haciendo estas
                                        preguntas:
                                    </Text>
                                    <List.Root gap={0} ml={4}>
                                        <List.Item>
                                            <Text
                                                fontSize={{ md: "lg", base: "sm" }}
                                                align="start"
                                                color="accent.500"
                                                fontWeight={400}
                                            >
                                                ¿Te gustaría que trataran de esa manera a algún
                                                familiar tuyo?
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text
                                                fontSize={{ md: "lg", base: "sm" }}
                                                align="start"
                                                color="accent.500"
                                                fontWeight={400}
                                            >
                                                ¿Actuarías de la misma manera o dirías lo mismo si
                                                estuviera presente algún familiar o nuestro director
                                                general?
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text
                                                fontSize={{ md: "lg", base: "sm" }}
                                                align="start"
                                                color="accent.500"
                                                fontWeight={400}
                                            >
                                                ¿Te daría vergüenza, a ti o a Guía, si la conducta
                                                se grabara en vídeo y se transmitiera en las
                                                noticias?
                                            </Text>
                                        </List.Item>
                                    </List.Root>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        Si se maneja o supervisa a un equipo de personas, se tiene
                                        la responsabilidad de hacerlos cumplir las reglas internas
                                        de Guía.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/privacy.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>C. Privacidad de información personal </strong>
                                        <br />
                                        Guía respeta la privacidad de la información de nuestro
                                        personal y cumple con las leyes que dictan como las empresas
                                        deben de tratar tal información. Todos los empleados,
                                        asesores y proveedores de servicios deben de tener especial
                                        cuidado al momento de manejar los datos personales de su
                                        propia información, la de otros empleados, asesores o
                                        proveedores de servicios y las de nuestros clientes. Guía se
                                        esfuerza en diseñar sistemas y políticas para mantener
                                        únicamente la información necesaria para la gestión de
                                        nuestra empresa y se exige al personal a que sigan los
                                        procedimientos de seguridad para garantizar que solamente
                                        las personas autorizadas tienen acceso a la información
                                        personal.
                                        <br /> <br />
                                    </Text>
                                </Stack>
                            </Flex>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                align="start"
                                color="accent.500"
                                fontWeight={400}
                                my={4}
                            >
                                <strong>D. Seguridad e higiene</strong>
                                <br />
                                En Guía tenemos el compromiso de brindar un lugar de trabajo que sea
                                seguro, al fomentar la salud y bienestar de nuestros empleados,
                                asesores y proveedores de servicios. El éxito de este compromiso
                                depende de que cada uno de nosotros cumpla con su parte. Si ocurre
                                algo en alguna de nuestras instalaciones que pudiera resultar
                                perjudicial para nuestros empleados, asesores, proveedores de
                                servicios, clientes o la comunidad, Guía debe de comunicar
                                abiertamente estas situaciones y desarrollar un plan para corregirlo
                                con rapidez y eficacia. Esperamos que todos nuestros empleados,
                                asesores y proveedores de servicios, informen de cualquier situación
                                que atente contra la seguridad, ya se dentro de nuestras
                                instalaciones o en las que Guía tenga alguna relación directa.
                                <br /> <br />
                            </Text>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/security.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        En Guía nunca tomaremos represalias contra ningún empleado,
                                        asesor o p por reporta un problema. Debido a que la
                                        seguridad e higiene son tan importantes para Guía, debemos
                                        mantenernos alejados de la influencia del alcohol, las
                                        drogas o cualquier otra sustancia que pudiera disminuir la
                                        capacidad para trabajar de manera segura y eficaz. A
                                        criterio de Guía se podrá ofrecer bebidas alcohólicas en los
                                        eventos de la empresa. Sin embargo, independientemente del
                                        lugar dónde se realicen estos eventos, nuestros estándares
                                        de conducta siguen vigentes y por lo tanto deben cumplirse.
                                        Los empleados, asesores y proveedores de servicios deben de
                                        recordar que en todo momento están representado a Guía y su
                                        reputación.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack mr={8}>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>E. Sobre la vestimenta</strong>
                                        <br />
                                        En Guía respetamos la diversidad, siempre buscando un
                                        espacio libre de discriminación y a su vez, también buscamos
                                        un ambiente laboral y profesional por lo que, dentro de las
                                        instalaciones de Guía, en los puntos de venta o en cualquier
                                        evento de Guía, debemos estar vestidos de acuerdo a las
                                        virtudes de esta empresa y siempre buscando dar una imagen
                                        profesional.
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/clothing.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack my={4}>
                            <Text
                                fontSize={{ md: "2xl", base: "xl" }}
                                align="start"
                                mb="8"
                                color="accent.500"
                                fontWeight="700"
                            >
                                4. CONDUCTA HACÍA NUESTROS SOCIOS COMERCIALES, CLIENTES Y
                                COMPETIDORES
                            </Text>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/treatment.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack mr={8}>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>A. Integridad y trato justo</strong>
                                        <br />
                                        Guía tiene éxito gracias a la confianza que se ha ganado por
                                        su integridad y su trato justo. La confianza de nuestros
                                        clientes, empleados, asesores de servicios, proveedores de
                                        servicios es el activo más valioso de Guía. Nuestros
                                        virtudes requieren siempre tratemos a todos con equidad,
                                        honestidad y respeto, sean clientes, empleados, asesores,
                                        proveedores de servicios, socios comerciales e incluso
                                        competidores. Por lo tanto, nadie que represente a Guía se
                                        aprovechará de nadie por medio de la manipulación, el fraude
                                        o la ocultación, el abuso de información privilegiada o
                                        confidencial, la interferencia con alguna relación
                                        contractual conocida ni ningún otro trato injusto. Ningún
                                        beneficio monetario justifica la realización de las
                                        actividades de Guía de esta manera.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                align="start"
                                color="accent.500"
                                fontWeight={400}
                                my={4}
                            >
                                <strong>
                                    B. Sobre conflictos de interés entre empleados y Guía
                                </strong>
                                <br />
                                Aunque no siempre se pueden evitar los conflictos, siempre se puede
                                minimizar su impacto negativo. Guía es consciente que sus empleados
                                tienen una amplia gama de intereses, por lo que intenta obtener el
                                equilibrio entre fomentar esos intereses y proteger su reputación,
                                marca y rentabilidad. Sin embargo, si los intereses de una persona y
                                de la empresa llega a entran en conflicto en algún momento, siempre
                                debemos de inclinarnos por la empresa y sus clientes. No hay ninguna
                                persona cuyos intereses sean más importantes que la organización en
                                su conjunto. Los conflictos de intereses surgen cuando una persona
                                que representa a Guía, actúa o tiene un interés con posibilidades de
                                afectar su objetividad, lealtad o rendimiento laboral.
                                <br />
                                Algunos ejemplos de conflicto entre empleado y empresa incluyen:
                                <br />
                            </Text>
                            <List.Root gap={0}>
                                <List.Item>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                    >
                                        Empleo en otro lugar.
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                    >
                                        Trabajo externo para o en la junta directiva de un cliente,
                                        proveedor, vendedor o competidor de Guía.
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                    >
                                        Tú o algún familiar cercano tiene algún interés en un
                                        proveedor, vendedor, socio, contratista, subcontratista o
                                        competidor de Guía. pública y sin subordinación)
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                    >
                                        Recibir algún favor, ganancia, obsequio, soborno u otros
                                        beneficios como resultado del cargo en la empresa.
                                    </Text>
                                </List.Item>
                            </List.Root>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                align="start"
                                color="accent.500"
                                fontWeight={400}
                                my={4}
                            >
                                Otros temas que pueden provocar conflicto de intereses son:
                                actividades externas a la empresa que puedan ayudar a un competidor,
                                el intercambio de obsequios e invitaciones cuando se crea una
                                obligación, pone al que lo da o lo recibe en una situación que
                                parece no ser objetiva o que se hace con la intención de influir
                                sobre una decisión comercial. De igual forma, se tiene prohibido en
                                Guía que exista subordinación de alguien con quien se tiene una
                                relación romántica o familiar, y de existir una relación entre
                                personal de Guía, esta deberá ser pública con el fin de poder
                                mantener un ambiente de trabajo profesional, que no caiga en
                                conflictos de interés o afecte el rendimiento laboral.
                            </Text>
                            <Stack
                                minW={{ base: "100%", md: "90%" }}
                                alignSelf="center"
                                alignItems="center"
                            >
                                <Image
                                    src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/conflict-interest.svg"
                                    maxW="80%"
                                    h="auto"
                                    w="80%"
                                    alt="image"
                                    objectFit="contain"
                                />
                            </Stack>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/competence.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>C. Competencia con Guía o sus clientes</strong>
                                        <br />
                                        Se prohíbe estrictamente competir con Guía o con sus
                                        clientes, de manera personal o ayudando a un competidor. Es
                                        inadecuado usar nuestros contactos o nuestro puesto en la
                                        empresa para que nuestros intereses financieros o
                                        comerciales particulares tengan una ventaja compitiendo con
                                        Guía o sus clientes.
                                        <br />
                                        <br />
                                        Como empleados, asesores o proveedores de servicios, tenemos
                                        la obligación de comunicar a Guía de promover algún negocio
                                        cuando surja la oportunidad, solo si Guía rechaza de manera
                                        expresa y por escrito, se permite que actuemos de manera
                                        personal o en favor de otra persona, siempre y cuando no se
                                        actúe en nombre de Guía.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>D. Participación pública y política</strong>
                                        <br />
                                        Se invita a los empleados de Guía a que participen en los
                                        asuntos políticos, educativos y normativos que afectan a
                                        nuestras vidas, comunidades y negocios. No se permite a
                                        ningún empleado, asesor o proveedor de servicios usar el
                                        nombre ni el logotipo de Guía, ni identificarse como parte
                                        de la empresa, sin obtener previo consentimiento por
                                        escrito.
                                        <br />
                                        <br />
                                        En Guía no realizamos ninguna contribución política y ningún
                                        empleado, asesor o proveedor de servicios podrá realizar
                                        contribuciones políticas en nombre de Guía. Guía únicamente
                                        participará en los asuntos públicos con aprobación del
                                        Departamento Legal.
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/public-participation.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/social-participation.svg"
                                        maxW="60%"
                                        h="auto"
                                        w={{ base: "35%", md: "60%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>
                                            E. Participación en los medios y redes sociales
                                        </strong>
                                        <br />
                                        Guía invita a que cuando se usen redes sociales, se haga de
                                        manera responsable ya que, como empleado, asesor, proveedor
                                        de servicios representa nuestra marca y es el encargado de
                                        proteger nuestra reputación. Una conducta inadecuada,
                                        compartir información confidencial, acoso, el uso excesivo
                                        de sistemas de la empresa para asuntos personales y el
                                        fraude se tratan de la misma manera, tanto si se han
                                        cometido en línea como en persona.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                        mr={{ base: 0, md: 8 }}
                                    >
                                        <strong>F. Peticiones de compañeros</strong>
                                        <br />
                                        La administración de Guía puede permitir una venta ocasional
                                        de productos o la petición de donativos para causas
                                        benéficas, siempre que tal actividad no interfiera con las
                                        operaciones de la empresa ni ponga a nadie en Guía bajo
                                        presión para comprar un producto o participar en un
                                        programa. Está prohibido exigir a un empleado que participe
                                        en una oración o ritual religioso, tanto en la oficina como
                                        fuera de ella.
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/requests.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/fair-competition.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                        mr={{ base: 0, md: 8 }}
                                    >
                                        <strong>G. Competencia justa</strong>
                                        <br />
                                        Nuestros virtudes buscan que apoyemos la libre competencia.
                                        La legislación relativa a la competencia (por ejemplo, las
                                        leyes contra los monopolios) son complejas, e infringirlas
                                        conlleva sanciones graves que incluyen multas y penas de
                                        prisión para los empleados específicos. De esa manera, todos
                                        nosotros debemos asegurarnos de que nuestra conducta sea
                                        coherente con nuestros virtudes y que cumpla la ley.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                        mr={{ base: 0, md: 8 }}
                                    >
                                        <strong>H. Trato con gobierno / anticorrupción</strong>
                                        <br />
                                        Aunque puede ser una práctica aceptable en el sector privado
                                        el intercambio de obsequios, almuerzos, invitaciones,
                                        transporte o alojamiento; con los funcionarios de gobierno
                                        está estrictamente prohibido. Además de infringir la ley, es
                                        posible que un paso en falso en este aspecto pudiera poner
                                        en peligro los proyectos y actividades de nuestros clientes
                                        y, por lo tanto, los de Guía.
                                        <br /> <br />
                                        Todos en Guía tenemos la responsabilidad de evitar en
                                        participar en cualquier manera en actos de corrupción, así
                                        como de informar de estos actos cuándo ocurran. No cumplir
                                        con estos lineamientos puede resultar en graves
                                        consecuencias tanto para la persona que caiga en la
                                        infracción como para Guía. En caso de cualquier duda se debe
                                        de acudir al Departamento Legal.
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/anti-corruption.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/inteligent-competence.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                        mr={{ base: 0, md: 8 }}
                                    >
                                        <strong>I. Inteligencia competitiva</strong>
                                        <br />
                                        Guía reúne y utiliza la información únicamente de
                                        conformidad con la ley y nuestros altos estándares éticos, y
                                        siempre respetando la confidencialidad de la información de
                                        nuestros clientes y competidores. La ley prohíbe obtener
                                        información por cualquier medio no lícito, como lo puede ser
                                        robo, soborno, simulación, etc. De igual forma, es muy
                                        importante obtener la información de nuestra competencia de
                                        manera ética, como lo puede ser los siguientes lineamientos:
                                    </Text>
                                    <List.Root gap={0}>
                                        <List.Item>
                                            <Text
                                                fontSize={{ md: "lg", base: "sm" }}
                                                align="start"
                                                color="accent.500"
                                                fontWeight={400}
                                                pb={2}
                                                mr={{ base: 0, md: 8 }}
                                            >
                                                No dar información falsa de Guía.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text
                                                fontSize={{ md: "lg", base: "sm" }}
                                                align="start"
                                                color="accent.500"
                                                fontWeight={400}
                                                pb={2}
                                                mr={{ base: 0, md: 8 }}
                                            >
                                                No utilizar a los empleados de nuestra competencia
                                                como fuentes indebidas de información confidencial.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text
                                                fontSize={{ md: "lg", base: "sm" }}
                                                align="start"
                                                color="accent.500"
                                                fontWeight={400}
                                                pb={2}
                                                mr={{ base: 0, md: 8 }}
                                            >
                                                Como empleados, asesores o proveedores de servicios
                                                e incluso candidatos de Guía no debemos divulgar
                                                información confidencial de Guía, ni de sus otros
                                                empleadores.
                                            </Text>
                                        </List.Item>
                                        <List.Item>
                                            <Text
                                                fontSize={{ md: "lg", base: "sm" }}
                                                align="start"
                                                color="accent.500"
                                                fontWeight={400}
                                                pb={2}
                                                mr={{ base: 0, md: 8 }}
                                            >
                                                No se usará información confidencial que se haya
                                                obtenido de otra empresa, sobre todo si se ha
                                                marcado como confidencial, a no ser que se tenga
                                                permiso expreso para ello. Si un tercero trata de
                                                compartir información clasificada sin antes haber
                                                firmado un acuerdo de confidencialidad (NDA) no se
                                                puede aceptar esa esa información.
                                            </Text>
                                        </List.Item>
                                    </List.Root>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                        mr={{ base: 0, md: 8 }}
                                    >
                                        Cualquier duda sobre la confidencialidad de la información
                                        se debe de acudir al Departamento Legal.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                        mr={{ base: 0, md: 8 }}
                                    >
                                        <strong>J. Información de nuestros clientes</strong>
                                        <br />
                                        Todo uso inadecuado de información confidencial de nuestros
                                        clientes debilita la confianza que han depositado en
                                        nosotros y daña nuestra relación con ellos.
                                        <br /> <br />
                                        Además, la aceptación de la información confidencial de los
                                        clientes crea una responsabilidad legal de protegerla. Todos
                                        nosotros debemos asegurarnos de que seguimos las mismas
                                        medidas de seguridad para proteger la información de los
                                        clientes que las que seguimos para la propia información
                                        confidencial de Guía.
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/client-data.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={8}
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/copy.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                        mr={{ base: 0, md: 8 }}
                                    >
                                        <strong>K. Derechos de autor</strong>
                                        <br />
                                        No haremos uso indebido del material con derechos de autor
                                        de ninguna otra entidad. El reenvío de los materiales
                                        proporcionados por otras empresas a empleados, asesores,
                                        proveedores de servicios o clientes de Guía, o su
                                        publicación, puede constituir una violación de las leyes
                                        sobre la propiedad intelectual y la política de Guía, y
                                        podrían someternos a sanciones monetarias u otro tipo de
                                        sanciones.
                                    </Text>
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mt={8} mb={4}>
                            <Text
                                fontSize={{ md: "2xl", base: "xl" }}
                                align="start"
                                mb="8"
                                color="accent.500"
                                fontWeight="700"
                            >
                                5. CONDUCTA HACIA LOS RECURSOS DE GUÍA
                            </Text>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/correct-usage.svg"
                                        maxW="80%"
                                        h="auto"
                                        w="80%"
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>
                                            A. Protección y uso correcto de la propiedad de la
                                            empresa
                                        </strong>
                                        <br />
                                        Todos tenemos la responsabilidad de cuidar los activos de la
                                        empresa (instalaciones, el equipo, los materiales, la
                                        propiedad, la tecnología, la información y la marca de
                                        Guía). La propiedad de Guía debe usarse únicamente con
                                        propósitos del negocio y debemos tomar las medidas
                                        necesarias para evitar su robo, daño o mal uso.
                                        <br /> <br />
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                            >
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>B. Marca y reputación</strong>
                                        <br />
                                        Acciones o actividades de algunas personas fuera del
                                        contexto de trabajo se han asociado con Guía, ya sea de
                                        manera correcta o no. Por ello, los líderes en la empresa
                                        deben asegurarse de que nada de lo que hacen en el trabajo
                                        ni en su vida personal afectará de manera adversa a la
                                        marca.
                                        <br /> <br />
                                        Todo material, publicación, base de datos y otros programas
                                        creados por o para Guía son propiedad intelectual que le
                                        pertenecen a esta. Todos los empleados, asesores,
                                        proveedores de servicios y demás personas que tengan acceso
                                        a estas creaciones deben de reconocer que le pertenecen a
                                        Guía. Igual que con el material de oficina proporcionado por
                                        la empresa, no pueden llevarse la propiedad intelectual al
                                        finalizar su empleo o contratación.
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/reputation.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/confidentiality.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>C. Información confidencial y registrada</strong>
                                        <br />
                                        Nuestra información confidencial y registrada nos otorga una
                                        ventaja frente a nuestros competidores del mercado. Su
                                        divulgación podría dañar a Guía. La política de Guía nos
                                        exige a todos mantener segura la información confidencial de
                                        la empresa. Esto aplica a cualquier información que no sea
                                        de acceso para el público, como lo es información sobre
                                        nuestras finanzas, estrategias, operaciones, clientes,
                                        información sobre nuestros empleados, asesores, proveedores
                                        de servicios y demás personas que tengan alguna relación con
                                        Guía.
                                        <br /> <br />
                                        Es necesario que todas las personas que tengan acceso a la
                                        información confidencial de Guía firmen un reconocimiento de
                                        sus responsabilidades para el debido mantenimiento de la
                                        confidencialidad de dicha información.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                            >
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>D. Comunicación electrónica</strong>
                                        <br />
                                        Los sistemas de comunicación electrónica, como el acceso a
                                        internet, correo electrónico, servicios de buzón de voz,
                                        teléfono, son herramientas esenciales para el debido
                                        funcionamiento de nuestras actividades.
                                        <br /> <br />
                                        Debemos de usar estos sistemas acordes con nuestros
                                        virtudes, por lo que es fundamental que estos sistemas sean
                                        utilizados únicamente para los objetivos del negocio. Aunque
                                        se pueda utilizar los sistemas de la empresa para uso
                                        personal, Guía no autoriza que se utilice de ninguna manera
                                        que pueda afectar negativamente a tu rendimiento o el de
                                        otra persona, o que sea contrario a nuestros virtudes u
                                        otras políticas de Guía.
                                        <br /> <br />A través de los años, el uso de sistemas de
                                        comunicación comunicación electrónica ha transformado
                                        totalmente la forma en la que nos comunicamos. Sin embargo,
                                        al ser tan accesible el uso de estas tecnologías, aumenta el
                                        riesgo de su uso inapropiado o de deficiencias en la
                                        comunicación. Por ello es imperativo que tengamos el mismo
                                        cuidado con los mensajes electrónicos como el que tenemos
                                        con cualquier documento escrito. En el peor escenario se le
                                        podría atribuir a Guía mensajes que incluyan puntos de vista
                                        que van en contra de las virtudes que Guía representa, como
                                        lo pueden ser contenido despectivo, opiniones personales,
                                        políticas, contenido blasfemo, ofensivo o sexual, por lo que
                                        degradarían la imagen Guía e inclusive podrían causar alguna
                                        responsabilidad civil.
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/comunication.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/information-requests.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>
                                            E. Trato con los medios de comunicación y otras
                                            solicitudes de información
                                        </strong>
                                        <br />
                                        Guía comunica, de manera directa o indirecta, sus negocios y
                                        asuntos relacionados con las propiedades inmobiliarias con
                                        el público a través de los medios de comunicación. Solo
                                        determinadas personas tienen la autorización a hablar en
                                        nombre de Guía.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={4}
                            >
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>F. Registros contables</strong>
                                        <br />
                                        Casi todos contribuimos en alguna forma a generar los
                                        estados financieros de Guía. Todos los documentos, reportes
                                        e información preparados por o para Guía o a petición de
                                        alguna autoridad son importantes para garantizar que
                                        nuestros informes financieros tienen la exactitud que nos
                                        exige la ley.
                                        <br />
                                        <br />
                                        Tenemos la obligación de entregar a las personas
                                        correspondientes, reportes con información completa, exacta,
                                        transparente y oportuna. Para cumplir con esta obligación,
                                        cada registro comercial que hagamos o aprobemos debe ser
                                        exacto, completo y confiable. Todo incumplimiento de estas
                                        políticas podría generar para Guía y sus representantes,
                                        obligaciones financieras y sanciones legales graves.
                                        <br />
                                        <br />
                                        Para que estos controles sean efectivos es indispensable que
                                        tengamos integridad, honestidad y comunicación en toda la
                                        empresa.
                                    </Text>
                                </Stack>
                                <Stack
                                    minW={{ base: "100%", md: "30%" }}
                                    alignSelf="center"
                                ></Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/registry-guard.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>G. Resguardo de los registros de la empresa</strong>
                                        <br />
                                        Es imperativo el correcto mantenimiento de la documentación
                                        de la empresa para el debido cumplimiento de la legislación
                                        y las regulaciones aplicables. Para cumplir con estas leyes
                                        y regulaciones, hemos creado políticas para el debido
                                        resguardo de la documentación de la empresa, cuidando que se
                                        respeten los plazos que se nos exigen como empresa para
                                        conservar documentación.
                                        <br />
                                        <br />
                                        Los registros deben conservarse o destruirse únicamente de
                                        acuerdo con los establecido en las políticas de la compañía.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                            >
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>H. Cooperación con las investigaciones</strong>
                                        <br />
                                        Para Guía es muy importante saber cuando ocurren actos
                                        indebidos en nuestra empresa. Por ello, destinaremos los
                                        recursos necesarios para investigar cualquier sospecha de
                                        mala conducta cuando se presente. Cuando esto pase, es de
                                        suma importancia que todas las personas que sean necesarias
                                        para la investigación cooperen por completo, de manera
                                        honesta e integra, para poder descubrir la veracidad de los
                                        hechos y poder tomar las acciones correctas y
                                        correspondientes para rectificar los actos indebidos.
                                        <br />
                                        <br />
                                        Por otra parte, si recibes alguna solicitud o aviso del
                                        gobierno, debes de comunicarlo de inmediato a dirección
                                        jurídica, o a los directivos principales, esto para que Guía
                                        pueda cooperar con los requerimientos legales y tome las
                                        acciones correspondientes.
                                    </Text>
                                </Stack>
                                <Stack minW={{ base: "100%", md: "40%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/investigation.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                mt={4}
                            >
                                <Stack minW={{ base: "100%", md: "30%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/insider-information.svg"
                                        maxW="80%"
                                        h="auto"
                                        w={{ base: "50%", md: "80%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>I. Información privilegiada</strong>
                                        <br />
                                        Muchos tenemos acceso a información de Guía la cuál no tiene
                                        acceso el público en general, nuestros clientes, socios
                                        comerciales y competidores. Es muy común que esa información
                                        sea de gran importancia, como lo puede ser, las utilidades
                                        de la empresa, el rendimiento de Guía, ganancias o pérdidas,
                                        juicios, etc. Sin importar dónde obtuviste esa información
                                        privilegiada, no podemos utilizar esa información importante
                                        que no es pública para ningún fin. Tan delicada es la
                                        información, que uno debe de tener mucho cuidado de no
                                        revelar la información a cualquier persona no autorizada,
                                        incluyendo familiares o amigos.
                                        <br />
                                        <br />
                                        Las infracciones por revelar esta información pueden ser muy
                                        graves y podrían generarle grandes daños a Guía y a las
                                        personas interesadas en la empresa.
                                        <br />
                                        <br />
                                        Si no estás seguro sobre este tema, debes de evitar
                                        comerciar o actuar de otro modo hasta no haberlo consultado
                                        con dirección jurídica y haya certeza de que se está
                                        cumpliendo con nuestras políticas y con la ley.
                                    </Text>
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mt={8} mb={4}>
                            <Text
                                fontSize={{ md: "2xl", base: "xl" }}
                                align="start"
                                mb="8"
                                color="accent.500"
                                fontWeight="700"
                            >
                                6. CONDUCTA HACIA LA COMUNIDAD
                            </Text>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                my={4}
                            >
                                <Stack minW={{ base: "100%", md: "20%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/responsability.svg"
                                        maxW="35%"
                                        h="auto"
                                        w={{ base: "25%", md: "35%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>A. Responsabilidad corporativa</strong>
                                        <br />
                                        En Guía estamos comprometidos con la integridad, servicio y
                                        excelencia, por lo que la empresa debe de lanzar iniciativas
                                        relacionadas con el cuidado del medio ambiente, ética y
                                        cumplimiento, gobierno, seguridad e higiene, y filantropía.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                my={4}
                            >
                                <Stack minW={{ base: "100%", md: "20%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/help.svg"
                                        maxW="35%"
                                        h="auto"
                                        w={{ base: "25%", md: "35%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>B. Ayuda a la comunidad</strong>
                                        <br />
                                        Guía debe ser consciente de las necesidades y preocupaciones
                                        de la comunidad, puesto que conciernen a nuestras
                                        actividades y nuestros clientes, y trabajar de manera
                                        constructiva con las personas y autoridades adecuadas para
                                        resolver problemas de diversa índole. Nuestros esfuerzos por
                                        apoyar a la comunidad vienen por parte de nuestro equipo que
                                        buscan impulsar estas iniciativas.
                                    </Text>
                                </Stack>
                            </Flex>
                            <Flex
                                direction={{ base: "column", md: "row" }}
                                alignContent="center"
                                alignItems="center"
                                my={4}
                            >
                                <Stack minW={{ base: "100%", md: "20%" }} alignSelf="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/codigo-conducta/codigo-de-etica/eco-friendly.svg"
                                        maxW="25%"
                                        h="auto"
                                        w={{ base: "20%", md: "25%" }}
                                        alt="image"
                                        objectFit="contain"
                                    />
                                </Stack>
                                <Stack>
                                    <Text
                                        fontSize={{ md: "lg", base: "sm" }}
                                        align="start"
                                        color="accent.500"
                                        fontWeight={400}
                                        pb={2}
                                    >
                                        <strong>C. Cuidado al medio ambiente</strong>
                                        <br />
                                        Guía está decidida a apoyar las buenas prácticas
                                        medioambientales y responde con responsabilidad a las
                                        preguntas y preocupaciones de nuestras partes interesadas
                                        acerca de nuestras acciones medioambientales.
                                    </Text>
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack mt={8} mb={4}>
                            <Text
                                fontSize={{ md: "2xl", base: "xl" }}
                                align="start"
                                mb="4"
                                color="accent.500"
                                fontWeight="700"
                            >
                                7. CONCLUSIÓN
                            </Text>
                            <Text
                                fontSize={{ md: "lg", base: "sm" }}
                                align="start"
                                color="accent.500"
                                fontWeight={400}
                                py={2}
                            >
                                Todos en Guía tenemos la obligación de tratar a nuestros compañeros
                                y a otros con respeto, a representar a Guía con integridad, y a
                                apoyar las virtudes de servicio y excelencia que dan gran valor a
                                Guía. Las virtudes son la esencia de los estándares que debemos
                                seguir en la realización de nuestras actividades.
                            </Text>
                        </Stack>
                    </Box>
                </Flex>
            </Container>
            <Footer esGuiaRent={false} />
        </>
    );
};

export default CodigoDeEtica;
